angular.module('ihestiaCommonDirectives')
  .controller('ihestiaApplicationErrorCtrl', ['$scope', 'ihestiaPlatformHelper',
    function($scope, ihestiaPlatformHelper) {
      $scope.isJupiter = ihestiaPlatformHelper.isJupiter();
    }]);